import { render, staticRenderFns } from "./PptIcon.vue?vue&type=template&id=6c759f00&"
import script from "./PptIcon.vue?vue&type=script&lang=js&"
export * from "./PptIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports